'use client'

import { BreakdownEnum } from '../types'
import { BreakdownItem } from './item'
import { useTranslations } from 'next-intl'

export function BreakdownViews() {
  const t = useTranslations('analytics')
  const breakdownItems = Object.entries(BreakdownEnum)

  return (
    <div className="grid grid-cols-2 gap-4 w-full mt-8">
      {breakdownItems.map(([key, value]) => (
        <BreakdownItem
          key={key}
          breakdown={value}
          label={t(key as 'source' | 'page' | 'country' | 'device')}
        />
      ))}
    </div>
  )
}
